import React from "react";


// import CreditCard from "../assets/Images/creditcard.jpg";
// import Header from "../Components/Header";
// import Lowinterest from '../assets/Images/lowinterest.png'
// import Travelcard from '../assets/Images/travelcard.png'
// import cashbackcard from '../assets/Images/cashbackcard.png'
// import Black from '../assets/Images/black.png'
// import CashbackIcon from "../assets/Images/cashback-icon.png";
// import RewardsIcon from "../assets/Images/rewards-icon.png";
// import LowInterestIcon from "../assets/Images/low-interest-icon.png";

const Creditcard = () => {
  return (
    <div>
      <div className=" bg-gray-50">
                <div className="bg-darkBlue text-white py-12   text-center h-[50vh]">
                    <h1 className="text-4xl font-bold  pt-20">Exclusive Credit Card Offers</h1>
                    <p className="mt-4 text-lg">
                    Apply now and enjoy limited-time offers with amazing rewards, cashback, and more!
                    </p>
                </div>
            </div> 
    <section className="py-12  bg-blue-50">
    
      <div className="max-w-screen-xl mx-auto px-6 md:px-12">
        {/* Best Offers Banner */}
        

        {/* Credit Card Options */}
        <h3 className="text-2xl font-bold text-black mb-6 text-center  uppercase">Best Credit Card Options</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 ">
          {/* Credit Card 1 */}
          <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all transition-transform hover:scale-105">
            
            <h4 className="text-xl font-semibold text-blue-800 font-cabinet">Premium Rewards Card</h4>
            <ul className="space-y-3 text-gray-600 mt-4 font-nunito list-disc">
              <li>Earn 3% cashback on travel</li>
              <li>1% cashback on all other purchases</li>
              <li>Exclusive access to airport lounges</li>
            </ul>
            <button className="mt-6 bg-blue-600 text-white font-semibold py-3 px-8 rounded-md hover:bg-blue-700 font-cabinet">
              Learn More
            </button>
          </div>

          {/* Credit Card 2 */}
          <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all transition-transform hover:scale-105">
            
            <h4 className="text-xl font-semibold text-blue-800 font-cabinet">Cashback MasterCard</h4>
            <ul className="space-y-3 text-gray-600 mt-4 font-nunito list-disc">
              <li>Unlimited 2% cashback on all purchases</li>
              <li>No annual fee</li>
              <li>Bonus $200 after your first $500 spend</li>
            </ul>
            <button className="mt-6 bg-blue-600 text-white font-semibold py-3 px-8 rounded-md hover:bg-blue-700 font-cabinet">
              Learn More
            </button>
          </div>

          {/* Credit Card 3 */}
          <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all transition-transform hover:scale-105">
            
            <h4 className="text-xl font-semibold text-blue-800 font-cabinet" >Travel Rewards Card</h4>
            <ul className="space-y-3 text-gray-600 mt-4 font-nunito list-disc">
              <li>Earn 5x points on travel and dining</li>
              <li>Free global Wi-Fi and travel insurance</li>
              <li>Access to exclusive travel experiences</li>
            </ul>
            <button className="mt-6 bg-blue-600 text-white font-cabinet font-semibold py-3 px-8 rounded-md hover:bg-blue-700">
              Learn More
            </button>
          </div>
        </div>

        {/* Best Services Section */}
        <h3 className="text-2xl font-bold text-blue-800 my-12 text-center font-cabinet">Our Best Credit Card Services</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {/* Cashback Service */}
          <div className="flex flex-col items-center bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all transition-transform hover:scale-105">
            
            <h4 className="text-xl font-semibold text-blue-800 font-nunito">Cashback Rewards</h4>
            <p className="text-gray-600 font-nunito">Earn cashback on every purchase, whether big or small. Get more out of your spending.</p>
          </div>

          {/* Rewards Service */}
          <div className="flex flex-col items-center bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all transition-transform hover:scale-105">
            
            <h4 className="text-xl font-semibold text-blue-800 font-cabinet">Travel & Dining Rewards</h4>
            <p className="text-gray-600 font-nunito">Unlock points and exclusive rewards for dining, travel, and other lifestyle purchases.</p>
          </div>

          {/* Low Interest Service */}
          <div className="flex flex-col items-center bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-all transition-transform hover:scale-105">
            
            <h4 className="text-xl font-semibold text-blue-800 font-cabinet">Low-Interest Rates</h4>
            <p className="text-gray-600 font-nunito">Enjoy the benefit of low-interest rates on your balances, making your credit card easier to manage.</p>
          </div>
        </div>
      </div>
    </section>
    </div>
  );
};

export default Creditcard;
